import { Component, Input } from '@angular/core';
import { CasinoSliderItemModel, CasinoSliderListModel } from '@components/casino/casino.model';
import { CasinoHelper } from '@components/casino/casino.helper';
import { AppTimerService } from '@services/app-timer.service';

@Component({
  selector: 'casino-banner-component',
  template: `<div class="slider">
    <ng-container *ngFor="let sliderItem of sliderList.sliderBannerList; let i = index">
      <img [src]="sliderItem.imageUrl" [class.active]="i === currentImageIndex" [class.next]="i === nextImageIndex" class="slider-image bg-filter" alt="" />
      <img
        [src]="sliderItem.imageUrl"
        [class.active]="i === currentImageIndex"
        [style.z-index]="i === currentImageIndex ? 10 : 1"
        [class.next]="i === nextImageIndex"
        class="slider-image"
        alt=""
        (click)="this.selectSliderControl(sliderItem)" />
    </ng-container>
  </div> `,
  styleUrls: ['./casino.sass'],
  providers: [AppTimerService],
})
export class CasinoBannerComponent {
  @Input() sliderList: CasinoSliderListModel;
  currentImageIndex = 0;
  nextImageIndex = 1;

  constructor(private _CasinoHelper: CasinoHelper, private _Timer: AppTimerService) {}

  ngOnInit(): void {
    this.startSlideshow();
  }

  startSlideshow() {
    this._Timer.setInterval(
      'imageAnimation',
      () => {
        this.currentImageIndex = this.nextImageIndex;
        this.nextImageIndex = (this.nextImageIndex + 1) % this.sliderList?.sliderBannerList?.length;
      },
      3000
    );
  }

  selectSliderControl(sliderItem: CasinoSliderItemModel) {
    switch (sliderItem?.sliderType) {
      case 2:
        this._CasinoHelper.goGamesAction(sliderItem?.gameData);
        break;
      case 3:
        this._CasinoHelper.selectCasinoCategory(Number(sliderItem.routeId));
        break;
      case 4:
        this._CasinoHelper.selectCasinoProvider(Number(sliderItem.routeId));
        break;
    }
  }
}
